import { Show, UserButton } from "@clerk/react";
import { type FC } from "react";

import { PlanGiftIcon } from "~/components/AppBar/PlanGiftIcon";
import { AppSignUpIconButton } from "~/feature/auth/components/AppSignUpButton";

export const MobileUserButton: FC = () => {
  return (
    <>
      <Show when="signed-out">
        <AppSignUpIconButton />
      </Show>
      <Show when="signed-in">
        <UserButton />
        <PlanGiftIcon sx={{ marginTop: "auto", marginBottom: "auto" }} />
      </Show>
    </>
  );
};
